import FullPage from './FullPage';
import Slide from './Slide';

export {
  FullPage,
  Slide,
};



// WEBPACK FOOTER //
// ./src/components/Fullpage/index.jsx